export default __webpack_public_path__ + "static/media/vacancy icon.0bf937fc.svg";